import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import BaseLayout, { activeApplication, loadEnvironment } from './BaseLayout';
import LanguageSelectorVue from './LanguageSelector.vue';

export default defineComponent({
    extends: BaseLayout,
    components: {
        LanguageSelector: LanguageSelectorVue,
    },
    setup() {
        const logo = computed(() => {
            const extension = activeApplication.value === 'pit' ? 'png' : 'svg';
            return `/images/design/${activeApplication.value}/logo.${extension}`;
        });
        const styleLoaded = ref(false);
        const store = useStore();
        const loadedLanguage = computed(() => store.getters.loadedLanguage.key);
        const loadingLanguage = computed(() => store.getters.loadingLanguage);

        onMounted(() => {
            loadEnvironment();
            styleLoaded.value = true;
        });

        return {
            logo,
            styleLoaded,
            loadedLanguage,
            loadingLanguage,
        };
    },
});
